import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { DocumentTemplateDTO } from '../interfaces/documents/document-template-dto.interface';
import { DocumentValidationStatusDTO } from '../interfaces/documents/document-validation-status-dto.interface';
import { DocumentSignatureStatusDTO } from '../interfaces/documents/document-signature-status-dto.interface';
import { LibraryParagraphDto } from '../interfaces/documents/library-paragraph-dto.interface';
import { DocumentStatusDto } from '../interfaces/documents/document-status-dto.interface';
import { environment } from 'src/environments/environment';
import { DocumentFusionFieldsDTO } from '../models/iCourrier/document-template';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private iTemplateURL: string;
  private iCourrierURL: string;
  private documentsStatutes$: Observable<DocumentStatusDto[]>;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iTemplateURL = config.baseUrlDocumentEditor;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  public convertDocument(body: { editor: string | 'devexpress'; type: string; data: Blob }): Observable<Blob> {
    const form = new FormData();
    for (const property in body) {
      if (Object.prototype.hasOwnProperty.call(body, property)) {
        form.append(property, body[property]);
      }
    }
    return this.http.post(`${this.iTemplateURL}/DocumentProcessor/Convert`, form, { responseType: 'blob' });
  }

  public fetchLibraryParagraphs(): Observable<LibraryParagraphDto[]> {
    return this.http.get<LibraryParagraphDto[]>(`${this.iCourrierURL}/Global/BibliothequeParagraphes`);
  }

  /**
   * Fetches the document statutes and caches the result for the app lifetime (it rarely changes during a session).
   */
  public fetchDocumentsStatutes(): Observable<DocumentStatusDto[]> {
    if (!this.documentsStatutes$) {
      this.documentsStatutes$ = this.http.get<DocumentStatusDto[]>(`${this.iCourrierURL}/Global/Documents/Statutes`).pipe(shareReplay(1));
    }
    return this.documentsStatutes$;
  }

  public getGlobalTemplates(): Observable<DocumentTemplateDTO[]> {
    return this.http.get<DocumentTemplateDTO[]>(`${this.iCourrierURL}/Global/Documents/Templates`);
  }

  public getDocumentsStatutes(): Observable<DocumentStatusDto[]> {
    return this.http.get<DocumentStatusDto[]>(`${this.iCourrierURL}/Global/Documents/Statutes`);
  }
  public getDocumentStatutesByGlobal(id: number): Observable<DocumentStatusDto[]> {
    return this.http.get<DocumentStatusDto[]>(`${this.iCourrierURL}/Global/GlobalStatutes/${id}/DocumentStatutes`);
  }

  public getStatusValidationGlobal(): Observable<DocumentValidationStatusDTO[]> {
    return this.http.get<DocumentValidationStatusDTO[]>(`${this.iCourrierURL}/Global/Documents/ValidationStatutes`);
  }

  public getStatusSignatureGlobal(): Observable<DocumentSignatureStatusDTO[]> {
    return this.http.get<DocumentSignatureStatusDTO[]>(`${this.iCourrierURL}/Global/Documents/SignatureStatutes`);
  }

  public getFusionsField(): Observable<DocumentFusionFieldsDTO> {
    return this.http.get<DocumentFusionFieldsDTO>(`${this.iCourrierURL}/Global/Documents/Templates/FusionChamps`);
  }
}
